import styled from "styled-components";
import Select from "react-select";

export const SelectorControl = {
  minWidth: "215px",
  display: "inline-flex",
  height: "35px",
  padding: "14px 10px 14px 15px",
  alignItems: "center",
  gap: "10px",
  flexShrink: "0",
  borderRadius: "4px",
  border: "1px solid #4a4ca8",
  background: "#232459",
  color: "#ffffff"
};

export const Selector = styled(Select)`
  min-width: 115px;
  display: inline-flex;
  height: 35px;
  padding: 14px 10px 14px 15px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #4a4ca8;
  background: #232459;
  color: #ffffff;
`;
